import { render, staticRenderFns } from "./temp-dialog.vue?vue&type=template&id=4ab6df14&lang=pug&"
import script from "./temp-dialog.vue?vue&type=script&lang=js&"
export * from "./temp-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports